import { ReactNode } from 'react';
import { useRouter } from 'next/router';
import classNames from 'classnames';

import Arrow from 'assets/icons/arrow.svg';
import Button from '@components/atoms/Button';
import Url from 'types/Url';
import { FormattedMessage } from 'utils/intl';

import classes from './BackButton.module.scss';
import messages from './BackButton.messages';

type Props = {
  className?: string;
  href?: Url;
  onClick?: () => void;
  children?: ReactNode;
};

const BackButton = ({ className, href, onClick, children }: Props): JSX.Element => {
  const router = useRouter();

  return (
    <div className={classNames(classes.buttonWrapper, className)}>
      <Button
        color="secondary"
        variant="outlined"
        icon={<Arrow className={classes.buttonIcon} />}
        iconPosition="left"
        size="sm"
        onClick={onClick || (href ? () => router.push(href) : router.back)}
      >
        {children || <FormattedMessage {...messages.return} />}
      </Button>
    </div>
  );
};

export default BackButton;
